import { render, staticRenderFns } from "./MChart.vue?vue&type=template&id=ef8640d4"
import script from "./MChart.vue?vue&type=script&lang=js"
export * from "./MChart.vue?vue&type=script&lang=js"
import style0 from "./MChart.vue?vue&type=style&index=0&id=ef8640d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports